import { ColumnInfo, ColumnInfoList, DisplaySetting } from 'components/shared/display_setting'
import { SelectItem } from 'components/shared/input'
import { TableCell } from 'components/shared/widget'
import { TrainingLedger } from 'entities/training_ledger'
import { ReactNode, useMemo } from 'react'
import { Form } from 'utils/hooks'
import { TrainingLedgerViewModel } from 'view_models/training_ledger_view_model'

export const trainingLedgerColumnInfoList = (form?: Form<Record<string, unknown>>, vendorSelectItems?: SelectItem[]): ColumnInfoList => {
    return {
        tableName: '',
        values: [
            {
                align: 'center',
                name: '作成日',
                th: true,
                width: 100,
                form: form,
                orderAttr: 'training_ledger_master_id',
                searchType: { name: 'id', type: 'multiple_text' },
            },
            {
                align: 'center',
                name: '更新日',
                th: true,
                width: 100,
                form: form,
                orderAttr: 'transportation_report_id',
                searchType: { name: 'id', type: 'multiple_text' },
            },
            {
                align: 'center',
                name: 'ユーザー名',
                th: true,
                width: 100,
                form: form,
                searchType: { name: 'user_id', type: 'multiple_select', selectItems: [] },
            },
            {
                align: 'center',
                name: '年度',
                th: true,
                width: 100,
                form: form,
                orderAttr: 'training_ledger_master_year',
                searchType: { name: 'year', type: 'number' },
            },
            { align: 'center', name: '教育研修記録', th: true, width: 140, form: form },
            { align: 'center', name: '技能評価記録', th: true, width: 140, form: form },
        ],
    }
}

export type TrainingLedgerTableDataProps = {
    trainingLedger?: TrainingLedger
    displaySetting: DisplaySetting
}

export const TrainingLedgerTableData = ({ trainingLedger, displaySetting }: TrainingLedgerTableDataProps): JSX.Element => {
    const vm = new TrainingLedgerViewModel(trainingLedger ?? {})
    if (!trainingLedger) {
        return (
            <>
                {displaySetting.columnInfoList.values.map((_: ColumnInfo, index: number) => {
                    if (displaySetting.hiddenList.includes(index)) {
                        return <></>
                    } else {
                        return <TableCell key={index}></TableCell>
                    }
                })}
            </>
        )
    }

    const createCells = useMemo(() => {
        return (
            <>
                <TableCell align="center">{vm.createDate()}</TableCell>
                <TableCell align="center">{vm.updateDate()}</TableCell>
                <TableCell align="center">{trainingLedger.user?.fullName}</TableCell>
                <TableCell align="center">{trainingLedger.year}</TableCell>
                <TableCell align="center">{trainingLedger.trainingContentSet?.filter((t) => t.recordType === 'training').length}件</TableCell>
                <TableCell align="center">{trainingLedger.trainingContentSet?.filter((t) => t.recordType === 'accessment').length}件</TableCell>
            </>
        )
    }, [displaySetting.hiddenList])

    return createCells.props.children.filter((_: ReactNode, index: number) => !displaySetting.hiddenList?.includes(index)).map((cell: ReactNode) => cell)
}
